import { isValidPhoneNumber } from 'react-phone-number-input';
import { partial } from '../../../util/translation/translation';

const p = partial('validateErrors');

const validate = (values) => {
  const errors = {};
  if (!values.email) {
    errors.email = p('emailFieldCantBeEmpty');
  }
  // values.phone may be a string (from initialize) or { phone, code } (from renderCountryPhone)
  const phoneValue =
    values.phone && typeof values.phone === 'object'
      ? values.phone.phone
      : values.phone;
  if (!phoneValue) {
    errors.phone = `${p('phoneNumberFieldEmpty')}`;
  } else if (!isValidPhoneNumber(phoneValue)) {
    errors.phone = `${p('invalidPhoneNumber')}`;
  }
  return errors;
};
export default validate;
